import { LanguageType } from '../constants';

export const TranslationsHelper = {
  translate: (language, englishContent, arabicContent) => (language === LanguageType.English ? englishContent : arabicContent),
};
